<template>
    <div>
        <div v-if="show" class="chat-box">
            <div
                class="chat-max-container chat-flex chat-flex-column"
                style="border-radius: 5px; border: 1px solid #e1dbdb"
            >
                <div
                    v-if="objeto.canal != null"
                    class="chat-toolbar chat-card-primary chat-flex chat-card-small chat-flex-none chat-flex-middle chat-custom-color"
                    style="border-radius: 5px 5px 0px 0px"
                >
                    <div
                        role="navigation"
                        aria-label="primary"
                        class="chat-toolbar-nav"
                    >
                        <div class="chat-route-back chat-flex chat-flex-middle">
                            <div
                                class="chat-avatar chat-avatar-small chat-message-profile chat-flex-none"
                                style="border-radius: 30px"
                            >
                                <div
                                    class="chat-avatar-image"
                                    v-if="objeto.canal"
                                >
                                    <img
                                        v-if="objeto.canal.receptor"
                                        v-show="!objeto.canal.receptor.imagen"
                                        :src="
                                            'data:image/png;base64,' +
                                            objeto.canal.receptor.avatar
                                        "
                                        alt="Agent profile image"
                                    />
                                    <img
                                        v-if="objeto.canal.receptor"
                                        v-show="objeto.canal.receptor.imagen"
                                        :src="
                                            'data:image/png;base64,' +
                                            objeto.canal.receptor.imagen
                                        "
                                        alt="Agent profile image"
                                    />
                                </div>
                            </div>
                            &nbsp;&nbsp;
                            <span v-if="objeto.canal">
                                <span v-if="objeto.canal.receptor">
                                    {{ objeto.canal.receptor.nombres }}
                                    {{ objeto.canal.receptor.apellidos }}
                                    <br />
                                    <span
                                        v-if="objeto.canal.receptor.rol"
                                        style="
                                            color: #e73c3e;
                                            background: #fff;
                                            border-radius: 10px;
                                            padding: 2px 10px;
                                            font-size: 12px;
                                        "
                                    >
                                        {{ objeto.canal.receptor.rol.nombre }}
                                    </span>
                                </span>
                            </span>
                            <span v-else> Asesor virtual </span>
                        </div>
                    </div>

                    <div
                        role="navigation"
                        aria-label="secondary"
                        class="chat-margin-auto-left chat-flex-none chat-flex chat-flex-middle"
                    >
                        <div
                            class="chat-dropdown chat-toolbar-menu"
                            role="menu"
                        >
                            <button
                                @click.prevent="menu"
                                type="button"
                                title="Menu"
                                class="chat-header-text chat-margin-auto-left chat-flex-none chat-button-hover chat-button chat-button-text chat-button-color-inverse chat-tooltip"
                                data-text="Menu"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    width="24px"
                                    height="24px"
                                    viewBox="0 0 24 24"
                                    version="1.1"
                                >
                                    <g
                                        stroke="none"
                                        stroke-width="1"
                                        fill="none"
                                        fill-rule="evenodd"
                                    >
                                        <rect
                                            x="0"
                                            y="0"
                                            width="24"
                                            height="24"
                                        />
                                        <rect
                                            fill="#fff"
                                            x="4"
                                            y="5"
                                            width="16"
                                            height="3"
                                            rx="1.5"
                                        />
                                        <path
                                            style="opacity: 1"
                                            d="M5.5,15 L18.5,15 C19.3284271,15 20,15.6715729 20,16.5 C20,17.3284271 19.3284271,18 18.5,18 L5.5,18 C4.67157288,18 4,17.3284271 4,16.5 C4,15.6715729 4.67157288,15 5.5,15 Z M5.5,10 L18.5,10 C19.3284271,10 20,10.6715729 20,11.5 C20,12.3284271 19.3284271,13 18.5,13 L5.5,13 C4.67157288,13 4,12.3284271 4,11.5 C4,10.6715729 4.67157288,10 5.5,10 Z"
                                            fill="#fff"
                                            opacity="0.3"
                                        />
                                    </g>
                                </svg>
                            </button>
                            <div
                                class="chat-dropdown-menu chat-dropdown-menu-right"
                            >
                                <div>
                                    <button
                                        v-show="objeto.estado != 3"
                                        type="button"
                                        class="chat-text-left chat-flex chat-flex-middle chat-button chat-button-text chat-button-small"
                                    >
                                        <span style="width: 25px"
                                            ><i
                                                class="fa fa-user"
                                                style="width: 20px"
                                            ></i
                                        ></span>
                                        Cambiar nombre</button
                                    ><button
                                        @click.prevent="transcription"
                                        type="button"
                                        class="chat-text-left chat-flex chat-flex-middle chat-button chat-button-text chat-button-small"
                                    >
                                        <span style="width: 25px"
                                            ><i class="fa fa-envelope"></i
                                        ></span>
                                        Enviar transcripción</button
                                    ><button
                                        v-show="objeto.estado != 3"
                                        v-if="sound"
                                        @click.prevent="setSound(false)"
                                        type="button"
                                        class="chat-text-left chat-flex chat-flex-middle chat-button chat-button-text chat-button-small"
                                    >
                                        <span style="width: 1.6rem"
                                            ><i class="fa fa-volume-off"></i
                                        ></span>
                                        Deshabilitar sonido
                                    </button>
                                    <button
                                        v-show="objeto.estado != 3"
                                        v-if="!sound"
                                        @click.prevent="setSound(true)"
                                        type="button"
                                        class="chat-text-left chat-flex chat-flex-middle chat-button chat-button-text chat-button-small"
                                    >
                                        <span style="width: 1.6rem"
                                            ><i class="fa fa-volume-up"></i
                                        ></span>
                                        Habilitar sonido
                                    </button>
                                    <button
                                        v-show="objeto.estado != 3"
                                        @click.prevent="question()"
                                        type="button"
                                        class="chat-text-left chat-flex chat-flex-middle chat-button chat-button-text chat-button-small"
                                    >
                                        <span style="width: 1.6rem"
                                            ><i class="fa fa-power-off"></i
                                        ></span>
                                        Finalizar chat
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="chat-flex chat-flex-column chat-flex-1">
                    <div class="chat-router-view chat-flex chat-flex-1">
                        <div
                            class="chat-main-panel chat-custom-flex-1 chat-home-view chat-custom-flex-1"
                        >
                            <div
                                class="chat-chat-panel chat-custom-flex-1 ps"
                                style="margin-right: 0px"
                            >
                                <div
                                    class="chat-chat-panel-inner chat-flex chat-flex-column"
                                >
                                    <div
                                        v-if="objeto.canal == null"
                                        class="chat-card chat-card-danger chat-card-small chat-header-container chat-flex-none chat-header chat-custom-color"
                                    >
                                        <div class="chat-text-center">
                                            <div>
                                                <div>
                                                    <div
                                                        class="header-card card--text"
                                                    >
                                                        <p
                                                            class="chat-text-regular-4 chat-header-text chat-custom-color card--alignment-center"
                                                        >
                                                            <span
                                                                class=""
                                                                style=""
                                                                >Estamos aqui
                                                                para ayudarte,
                                                                consulta a
                                                                nuestro
                                                                asistente
                                                                virtual o
                                                                solicita la
                                                                asistencia de un
                                                                asesor.</span
                                                            >
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        v-if="objeto.id == null"
                                        id="chat-body"
                                        class="chat-body"
                                    >
                                        <div
                                            class="chat-form-width-100 chat-flex chat-flex-column"
                                        >
                                            <div class="card-container">
                                                <div class="card--form">
                                                    <div>
                                                        <div
                                                            id="chat-form-container"
                                                            style="width: 100%"
                                                        >
                                                            <div
                                                                class="chat-card chat-card-inverse chat-form-input chat-box-shadow-xsmall chat-card-small chat-custom-border-left"
                                                            >
                                                                <form
                                                                    id="chat-prechat-form"
                                                                    name="chat-prechat-form"
                                                                >
                                                                    <div>
                                                                        <fieldset>
                                                                            <div
                                                                                class="chat-form-wrapper chat-margin-small"
                                                                            >
                                                                                <input
                                                                                    class="chat-input"
                                                                                    v-model="
                                                                                        objeto.nombre
                                                                                    "
                                                                                    placeholder="Nombre"
                                                                                />
                                                                            </div>
                                                                        </fieldset>
                                                                    </div>
                                                                    <div>
                                                                        <fieldset>
                                                                            <div
                                                                                class="chat-form-wrapper chat-margin-small"
                                                                            >
                                                                                <input
                                                                                    v-model="
                                                                                        objeto.email
                                                                                    "
                                                                                    class="chat-input"
                                                                                    placeholder="Email"
                                                                                />
                                                                            </div>
                                                                        </fieldset>
                                                                    </div>
                                                                    <div>
                                                                        <fieldset>
                                                                            <div
                                                                                class="chat-form-wrapper chat-margin-small"
                                                                            >
                                                                                <textarea
                                                                                    maxlength="500"
                                                                                    v-model="
                                                                                        objeto.consulta
                                                                                    "
                                                                                    placeholder="Mensaje"
                                                                                    class="chat-textarea chat-padding-small chat-border-radius"
                                                                                ></textarea>
                                                                            </div>
                                                                        </fieldset>
                                                                    </div>
                                                                </form>
                                                                <div
                                                                    class="chat-form-footer"
                                                                >
                                                                    <button
                                                                        @click.prevent="
                                                                            begin
                                                                        "
                                                                        type="button"
                                                                        class="chat-margin-small-top chat-button-hover width-100 chat-custom-color chat-custom-border-color chat-button"
                                                                    >
                                                                        <p
                                                                            style="
                                                                                color: #fff;
                                                                            "
                                                                        >
                                                                            <i
                                                                                class="fa fa-send"
                                                                            ></i>
                                                                            Iniciar
                                                                        </p>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        v-if="objeto.id != null"
                                        id="chat-body-scroll"
                                        class="chat-body"
                                        style="
                                            overflow-y: scroll;
                                            height: 400px;
                                        "
                                    >
                                        <div
                                            class="chat-chat-message-container chat-margin-small-top"
                                        >
                                            <span
                                                v-for="(
                                                    item, index
                                                ) in mensajes"
                                                :key="index"
                                            >
                                                <div
                                                    v-if="
                                                        item.nfc_remitente_id == 1
                                                    "
                                                    class="chat-margin-small-bottom chat-flex chat-flex-bottom chat-message-block"
                                                >
                                                    <div
                                                        class="chat-message-group chat-flex-1 chat-margin-auto-left"
                                                    >
                                                        <div
                                                            class="chat-message-bubble"
                                                        >
                                                            <div
                                                                class="chat-flex chat-flex-bottom chat-visitor-chat"
                                                            >
                                                                <div
                                                                    class="chat-flex-none"
                                                                    style="
                                                                        min-width: 40px;
                                                                    "
                                                                >
                                                                    <time
                                                                        class="chat-timeago chat-time-display"
                                                                        >09:15</time
                                                                    >
                                                                </div>
                                                                <div
                                                                    class="chat-message-body chat-margin-xsmall-left"
                                                                >
                                                                    <div>
                                                                        <div
                                                                            class="chat-card chat-card-default chat-card-small chat-visitor-chat-bubble chat-text-regular-3"
                                                                        >
                                                                            <span
                                                                                class=""
                                                                                style=""
                                                                            >
                                                                                {{
                                                                                    item.mensaje
                                                                                }}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="clearfix"
                                                            ></div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div
                                                    v-if="item.nfc_receptor_id == 1"
                                                    class="chat-margin-small-bottom chat-flex chat-flex-bottom chat-message-block"
                                                >
                                                    <div
                                                        class="chat-message-group chat-flex-1"
                                                    >
                                                        <div
                                                            class="chat-message-bubble"
                                                        >
                                                            <div
                                                                class="chat-flex chat-flex-bottom chat-agent-chat"
                                                            >
                                                                <div
                                                                    class="chat-message-body chat-margin-xsmall-left chat-margin-xsmall-right"
                                                                >
                                                                    <div>
                                                                        <div
                                                                            class="chat-card chat-card-primary chat-card-small chat-agent-chat-bubble chat-text-regular-3"
                                                                        >
                                                                            <span
                                                                                class=""
                                                                                style=""
                                                                            >
                                                                                {{
                                                                                    item.mensaje
                                                                                }}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="chat-flex-none"
                                                                    style="
                                                                        min-width: 40px;
                                                                    "
                                                                >
                                                                    <time
                                                                        class="chat-timeago chat-time-display"
                                                                        >{{
                                                                            $filters.timeSince(
                                                                                item.created_at
                                                                            )
                                                                        }}</time
                                                                    >
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="clearfix"
                                                            ></div>
                                                        </div>
                                                        <p
                                                            v-if="objeto.canal"
                                                            class="chat-margin-xsmall-left chat-text-regular-2 chat-text-truncate"
                                                        >
                                                            <span
                                                                v-if="
                                                                    objeto.canal
                                                                        .receptor
                                                                "
                                                            >
                                                                {{
                                                                    objeto.canal
                                                                        .receptor
                                                                        .nombres
                                                                }}
                                                                {{
                                                                    objeto.canal
                                                                        .receptor
                                                                        .apellidos
                                                                }}
                                                            </span>
                                                        </p>
                                                    </div>
                                                </div>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    v-if="finished"
                    id="chat-form-container"
                    class="chat-max-end-chat"
                >
                    <div
                        class="chat-card chat-card-inverse chat-form-input chat-box-shadow-small chat-card-small"
                    >
                        <div>
                            ¿Está seguro de que desea finalizar este chat?
                            <div
                                class="chat-form-footer chat-flex chat-flex-middle chat-margin-small-top"
                            >
                                <button
                                    @click.prevent="finished = false"
                                    type="button"
                                    class="chat-cancel-button chat-margin-xsmall-right chat-button-hover chat-button"
                                >
                                    Cancelar</button
                                ><button
                                    @click.prevent="finish"
                                    type="button"
                                    class="chat-margin-xsmall-left chat-button-hover chat-custom-color chat-custom-border-color chat-button"
                                >
                                    Terminar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    v-if="objeto.id != null"
                    class="chat-card chat-card-inverse chat-card-xsmall chat-footer chat-flex-none"
                    style="
                        border-radius: 0px;
                        box-shadow: transparent 0px 0px 0px;
                    "
                >
                    <div id="chat-chatinput-container" style="">
                        <div class="chat-chatinput">
                            <div class="chat-chatinput-emojis">
                                <div
                                    class="chat-emoji-picker"
                                    style="display: none"
                                >
                                    <div class="chat-emoji-loading"></div>
                                </div>
                            </div>
                            <div
                                class="chat-chatinput-fileupload"
                                style="display: none"
                            >
                                <ul
                                    class="chat-chatinput-fileupload-list chat-flex chat-flex-wrap"
                                ></ul>
                                <input type="file" multiple="multiple" />
                            </div>
                            <div
                                class="chat-chatinput-wrap chat-flex chat-flex-wrap"
                            >
                                <textarea
                                    placeholder="Escribe y presiona [enter].."
                                    class="chat-chatinput-editor"
                                    style="height: 16px"
                                    v-model="message"
                                    @keypress.enter.prevent="write"
                                    :disabled="objeto.estado == 3"
                                ></textarea>
                                <div class="chat-chatinput-action-buttons">
                                    <button
                                        role="button"
                                        type="button"
                                        title="Upload File"
                                        aria-title="Upload File"
                                        aria-hidden="true"
                                        :disabled="objeto.estado != 3"
                                        aria-haspopup="menu"
                                        aria-expanded="false"
                                        data-text="Upload File"
                                        class="chat-chatinput-button chat-tooltip"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlns:xlink="http://www.w3.org/1999/xlink"
                                            width="24px"
                                            height="24px"
                                            viewBox="0 0 24 24"
                                            version="1.1"
                                        >
                                            <g
                                                stroke="none"
                                                stroke-width="1"
                                                fill="none"
                                                fill-rule="evenodd"
                                            >
                                                <rect
                                                    x="0"
                                                    y="0"
                                                    width="24"
                                                    height="24"
                                                />
                                                <path
                                                    d="M14,16 L12,16 L12,12.5 C12,11.6715729 11.3284271,11 10.5,11 C9.67157288,11 9,11.6715729 9,12.5 L9,17.5 C9,19.4329966 10.5670034,21 12.5,21 C14.4329966,21 16,19.4329966 16,17.5 L16,7.5 C16,5.56700338 14.4329966,4 12.5,4 L12,4 C10.3431458,4 9,5.34314575 9,7 L7,7 C7,4.23857625 9.23857625,2 12,2 L12.5,2 C15.5375661,2 18,4.46243388 18,7.5 L18,17.5 C18,20.5375661 15.5375661,23 12.5,23 C9.46243388,23 7,20.5375661 7,17.5 L7,12.5 C7,10.5670034 8.56700338,9 10.5,9 C12.4329966,9 14,10.5670034 14,12.5 L14,16 Z"
                                                    fill="#000000"
                                                    fill-rule="nonzero"
                                                    transform="translate(12.500000, 12.500000) rotate(-315.000000) translate(-12.500000, -12.500000) "
                                                />
                                            </g>
                                        </svg>
                                        <span
                                            class="chat-tooltip-hover bottom"
                                            style="
                                                left: 251.805px;
                                                right: unset;
                                                top: 442.609px;
                                            "
                                            >Upload File<span
                                                class="chat-tooltip-arrow"
                                                style="left: 30px"
                                            ></span
                                        ></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="chat-widget">
            <div class="chat-min-container">
                <button
                    v-show="!show"
                    @click.prevent="show = true"
                    type="button"
                    class="chat-custom-color chat-custom-border-color chat-button chat-button-circle chat-button-large"
                    tabindex="0"
                    style="
                        bottom: 0px;
                        left: 0px;
                        position: absolute;
                        z-index: 1000;
                        border: 0px;
                    "
                >
                    <div isroundwidget="true">
                        <div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 800 800"
                                height="32px"
                                width="32px"
                                role="img"
                                alt="Chat icon"
                                class="chat-min-chat-icon"
                            >
                                <path
                                    style="fill: #fff"
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M400 26.2c-193.3 0-350 156.7-350 350 0 136.2 77.9 254.3 191.5 312.1 15.4 8.1 31.4 15.1 48.1 20.8l-16.5 63.5c-2 7.8 5.4 14.7 13 12.1l229.8-77.6c14.6-5.3 28.8-11.6 42.4-18.7C672 630.6 750 512.5 750 376.2c0-193.3-156.7-350-350-350zm211.1 510.7c-10.8 26.5-41.9 77.2-121.5 77.2-79.9 0-110.9-51-121.6-77.4-2.8-6.8 5-13.4 13.8-11.8 76.2 13.7 147.7 13 215.3.3 8.9-1.8 16.8 4.8 14 11.7z"
                                ></path>
                            </svg>
                        </div>
                    </div>
                </button>

                <button
                    v-show="show"
                    @click.prevent="show = false"
                    type="button"
                    class="chat-custom-color chat-custom-border-color chat-button chat-button-circle chat-button-large"
                    tabindex="0"
                    style="
                        bottom: 0px;
                        left: 0px;
                        position: absolute;
                        z-index: 1000;
                        border: 0px;
                    "
                >
                    <div isroundwidget="true">
                        <div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 800 800"
                                height="25px"
                                width="25px"
                                role="img"
                                alt="Close icon"
                                class="chat-min-chat-icon"
                            >
                                <path
                                    style="fill: #fff"
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M466.24042,400.4053l272.927-275.99463c6.94586-8.76452,11.13092-20.00501,11.13092-32.20959 s-4.18506-23.42317-11.21857-32.29724l0.08765,0.10955c-8.76453-6.94588-20.005-11.13094-32.20959-11.13094 c-12.20453,0-23.42316,4.18505-32.29724,11.21858l0.10956-0.08765L401.84311,336.008L125.84851,60.0134 c-8.76452-6.94588-20.00501-11.13094-32.2096-11.13094s-23.42316,4.18506-32.29724,11.21858l0.10955-0.08765 C54.50535,68.77792,50.32029,80.01842,50.32029,92.223s4.18505,23.42317,11.21858,32.29724l-0.08764-0.10956l275.9946,275.99463 L61.45122,673.33234c-6.94588,8.76453-11.13094,20.005-11.13094,32.20959s4.18506,23.42316,11.21858,32.29724l-0.08765-0.1095 c8.19483,7.64703,19.2162,12.33606,31.33314,12.33606c0.83263,0,1.68717-0.02191,2.49789-0.06573h-0.10957 c0.54779,0.02191,1.20512,0.04382,1.86246,0.04382c11.32813,0,21.5388-4.71094,28.79144-12.29224l0.0219-0.02191 l275.99463-272.92703l272.92703,272.92703c7.2746,7.58136,17.48523,12.31415,28.81335,12.31415 c0.65735,0,1.29279-0.02191,1.95013-0.04382h-0.08765c0.72308,0.04382,1.55573,0.06573,2.38831,0.06573 c12.11694,0,23.16022-4.68903,31.37695-12.35797l-0.02185,0.02191c6.94586-8.76447,11.13092-20.005,11.13092-32.20959 c0-12.20453-4.18506-23.42316-11.21857-32.29724l0.08765,0.10956L466.24042,400.4053z"
                                ></path>
                            </svg>
                        </div>
                    </div>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    created() {
        var broadcast = window.Echo;
        if (broadcast != undefined) {
            broadcast
                .channel("channel-chat-state")
                .listen(".ChatsEvent", (event) => {
                    console.log("ChatsEvent", event);
                    if (event) {
                        if (event.data.token == this.objeto.token) {
                            this.objeto = event.data;
                            this.finished = false;
                            this.sound = true;
                            localStorage.removeItem("chatId");
                            localStorage.removeItem("chatSound");
                            this.playSound();
                            this.menu();
                        }
                    }
                });
            broadcast
                .channel("channel-chat-write")
                .listen(".MensajesEvent", (event) => {
                    console.log("MensajesEvent", event);
                    if (event) {
                        if (event.data[0].token == this.objeto.token) {
                            if (event.data[1].nfc_receptor_id != undefined) {
                                if (event.data[1].nfc_receptor_id == 1) {
                                    this.get();
                                    if (this.sound) {
                                        this.playSound();
                                    }
                                    this.scrolling();
                                }
                            }
                        }
                    }
                });
        }
    },
    watch: {
        show: function (val, old) {
            if (val) {
                setTimeout(() => {
                    this.scrolling();
                }, 1500);
            }
        },
    },
    mounted() {
        if (
            localStorage.getItem("chatId") == "" ||
            localStorage.getItem("chatId") == null
        ) {
            localStorage.setItem("chatId", Math.random().toString(36).slice(2));
            this.objeto.token = localStorage.getItem("chatId");
            this.sound = localStorage.getItem("chatSound") ?? true;
        } else {
            this.objeto.token = localStorage.getItem("chatId");
        }
        this.get();
    },
    data: function () {
        return {
            show: false,
            message: "",
            finished: false,
            sound: true,
            objeto: {
                token: null,
                nombre: null,
                email: null,
                consulta: null,
                estado: 0,
                canal: null,
            },
        };
    },
    methods: {
        get() {
            axios
                .get("/api/chat/" + this.objeto.token)
                .then((response) => {
                    let decode = response.decode ?? response;
                    if (decode.data) {
                        this.objeto = decode.data;
                        this.list();
                    }
                })
                .catch((error) => {});
        },
        playSound() {
            var audio = new Audio(
                "/theme/nfc/dist/assets/media/sounds/that-was-quick-606.mp3"
            );
            audio.play();
        },
        setSound(state) {
            this.menu();
            this.sound = state;
            localStorage.setItem("chatSound", this.sound);
        },
        question() {
            this.finished = true;
            this.menu();
        },
        transcription() {},
        menu() {
            if ($(".chat-dropdown-menu").hasClass("chat-open")) {
                $(".chat-dropdown-menu").removeClass("chat-open");
            } else {
                $(".chat-dropdown-menu").addClass("chat-open");
            }
        },
        scrolling() {
            if ($("#chat-body-scroll")[0] != undefined) {
                $("#chat-body-scroll").animate(
                    { scrollTop: $("#chat-body-scroll")[0].scrollHeight },
                    1000
                );
            }
        },
        begin() {
            axios
                .post("/api/chat", this.objeto)
                .then((response) => {
                    let decode = response.decode ?? response;
                    if (decode.data) {
                    }
                })
                .catch((error) => {});
        },
        list() {
            axios
                .get("/api/chat/" + this.objeto.token)
                .then((response) => {
                    let decode = response.decode ?? response;
                    if (decode.data) {
                    }
                })
                .catch((error) => {});
        },
        write() {
            if (this.message != "") {
                axios
                    .post("/api/chat/writing/" + this.objeto.id, {
                        mensaje: this.message,
                        auth: false,
                    })
                    .then((response) => {
                        let decode = response.decode ?? response;
                        this.objeto = decode.data;
                        this.message = "";
                        this.scrolling();
                    })
                    .catch((error) => {});
            }
        },
        finish() {
            axios
                .put("/api/chat/" + this.objeto.id, { estado: 3 })
                .then((response) => {
                    let decode = response.decode ?? response;
                    if (decode.data) {
                    }
                })
                .catch((error) => {});
        },
        cancel() {
            this.objeto = {
                token: null,
                nombre: null,
                email: null,
                consulta: null,
                estado: 0,
                canal: null,
            };
        },
    },
    computed: {
        mensajes() {
            let response = [];
            if (this.objeto.canal != null) {
                this.objeto.canal.mensajes.forEach((element) => {
                    response.push(element);
                });
            }
            return response;
        },
    },
};
</script>
